<template>

  <ancestryline-modal title="protocol.change-stage" id="protocol-change-stage-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-select v-model="stageToChange" label="forms.protocol.stage" class="p-col-12 p-md-6 p-lg-4" :options="stages" />
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('btn.save')" @click="save" class="p-ml-2 p-button-success"/>
      </div>
    </template>

  </ancestryline-modal>

</template>

<script>
import DialogService from "@/business/ModalBusiness";
import StageBusiness from "@/business/StageBusiness";
import ProtocolBusiness from "@/business/ProtocolBusiness";

export default {
  name: "ModalChangeStageProtocol",

  props: {
    protocol: {type: Object, default: ()=>{return{}}}
  },

  data(){
    return {
      stageToChange: null,
      stages: [],
    }
  },

  async mounted() {
    this.stages = await StageBusiness.getAllActive();
    this.stageToChange = this.protocol.stage;
  },

  methods: {

    close(){
      DialogService.closeModal();
    },

    async save(){
      const response = await ProtocolBusiness.changeStage(this.protocol.id, this.stageToChange);
      if(response){
        DialogService.closeModal(this.stageToChange);
      }
    }

  }

}
</script>

<style scoped>

</style>
